// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const TabListRoot = styled.div`
  position: relative;
`;

export const TabListContent = styled.div`
  scroll-behavior: smooth;
  height: 100%;
`;
